export class Activity {
    id: number;
    code: string;
    name: string;
    state: any;
}